import { Box, TextareaAutosize } from "@mui/material";
import { ReactElement } from "react";

interface BaseRejectReasonProps {
  content: string;
  className?: string;
  title?: string;
}

const BaseRejectReason = ({
  content,
  className,
  title,
}: BaseRejectReasonProps): ReactElement => {
  return (
    <Box className={`flex flex-col ${className}`}>
      <span className="text-red-500 !mb-1">
        {title || "差し戻し理由"}
      </span>
      <TextareaAutosize
        minRows={4}
        maxLength={1000}
        value={content}
        readOnly
        className={`custom-textarea`}
        style={{ width: "100%", resize: "none" }}
      />
    </Box>
  );
};

export default BaseRejectReason;
